var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Fragment } from "react";
import { createUseStyles } from "react-jss";
import { Form, FormStateStatus, OpacityOverlay } from "../..";
import { FormArray, FormConsumer } from "../../Form";
import { FormGridInput } from "../../forms/formGrid/FormGridInput";
import { TableBulkAction } from "./TableBulkAction";
import { V2TableBody, V2TableWrapper } from "./Table";
import { V2TableCell } from "./TableCell";
import { TableDrawer } from "./TableDrawer";
import { V2TableHeader } from "./TableHeader";
import { V2TableRowComponent } from "./TableRow";
import { getCellDataId, getCellDataTestId } from "../tableUtils";
import { getItemNodeFormatting, getBoolValueFromRow } from "./utilsV2Table";
import { TableRowAction } from "./TableRowAction";
import { TableLoading } from "./TableSkeleton";
import { getInlineFeedback } from "./InlineFeedback";
import { useTableContext } from "../../hooks/useTableContext";
export function V2TableForm(props) {
    var _a, _b, _c;
    var form = props.form;
    var showBulkAction = (_a = props === null || props === void 0 ? void 0 : props.headings) === null || _a === void 0 ? void 0 : _a.some(function (heading) { var _a; return (_a = heading.formComponent) === null || _a === void 0 ? void 0 : _a.bulkAction; });
    if (!form)
        return null;
    if (form.childForm) {
        return (React.createElement(Form, { values: (_b = form === null || form === void 0 ? void 0 : form.values) !== null && _b !== void 0 ? _b : {}, element: "div" },
            React.createElement(V2TableWrapper, __assign({}, props),
                React.createElement(V2TableHeader, __assign({}, props)),
                form.viewState === "edit" &&
                    form.type !== "checkbox" &&
                    showBulkAction ? (React.createElement(Fragment, null,
                    React.createElement(TableBulkAction, { headings: props === null || props === void 0 ? void 0 : props.headings, form: form }),
                    React.createElement(V2TableFormBody, __assign({}, props)))) : (React.createElement(V2TableFormBody, __assign({}, props))))));
    }
    else {
        return (React.createElement(Form, { values: (_c = form === null || form === void 0 ? void 0 : form.values) !== null && _c !== void 0 ? _c : {} },
            React.createElement(FormStateStatus, { saveState: form.saveState, messages: form.messages }),
            React.createElement(OpacityOverlay, { on: form.saveState === "saving" },
                React.createElement(V2TableWrapper, __assign({}, props),
                    React.createElement(V2TableHeader, __assign({}, props)),
                    form.viewState === "edit" &&
                        form.type !== "checkbox" &&
                        showBulkAction ? (React.createElement(Fragment, null,
                        React.createElement(TableBulkAction, { headings: props === null || props === void 0 ? void 0 : props.headings, form: form, dataId: props === null || props === void 0 ? void 0 : props.dataId, dataTestId: props === null || props === void 0 ? void 0 : props.dataTestId }),
                        React.createElement(V2TableFormBody, __assign({}, props)))) : form.type === "checkbox" ? (React.createElement(V2TableBody, __assign({}, props))) : (React.createElement(V2TableFormBody, __assign({}, props)))))));
    }
}
export function V2TableFormBody(props) {
    var gridClassName = useTableContext().gridClassName;
    var classes = useTableFormClasses();
    var form = props.form;
    var _a = form, values = _a.values, name = _a.name;
    var tableHasData = values[name].length > 0;
    if (!tableHasData)
        return React.createElement("div", null, "empty");
    if (props === null || props === void 0 ? void 0 : props.loading) {
        return React.createElement(TableLoading, __assign({}, props));
    }
    return (React.createElement(FormArray, { name: name },
        React.createElement(FormConsumer, null, function (_a) {
            var _b;
            var values = _a.values, errors = _a.errors, arrayIndex = _a.arrayIndex;
            return (React.createElement(V2TableRowComponent, __assign({ item: values, rowIndex: arrayIndex }, props, { gridClassName: gridClassName }),
                props.headings.map(function (heading, cellIndex) {
                    var _a, _b, _c, _d;
                    var cellDataId = getCellDataId(arrayIndex, props === null || props === void 0 ? void 0 : props.dataId);
                    var cellDataTestId = getCellDataTestId(arrayIndex, props === null || props === void 0 ? void 0 : props.dataTestId);
                    var overflowTooltipContent = undefined;
                    if (heading.tipFormatter) {
                        overflowTooltipContent = heading.tipFormatter(values);
                    }
                    var helperTooltipContent = undefined;
                    if ((_a = heading.formComponent) === null || _a === void 0 ? void 0 : _a.helperTooltip) {
                        helperTooltipContent =
                            (_b = heading.formComponent) === null || _b === void 0 ? void 0 : _b.helperTooltip(values);
                    }
                    return (React.createElement(V2TableCell, __assign({ colIndex: cellIndex + 1 }, props, { heading: heading, key: "".concat(arrayIndex).concat(cellIndex), className: classes.cellForm, dataId: cellDataId && "".concat(cellDataId, "-").concat(cellIndex), dataTestId: cellDataTestId && "".concat(cellDataTestId, "-").concat(cellIndex), tooltipContent: overflowTooltipContent, inlineFeedback: getInlineFeedback(props === null || props === void 0 ? void 0 : props.feedback, props === null || props === void 0 ? void 0 : props.rowKey, values, heading) }), heading.formComponent &&
                        !getBoolValueFromRow(values, (_c = heading.formComponent) === null || _c === void 0 ? void 0 : _c.hidden) ? (React.createElement(FormGridInput, { column: heading.formComponent, labelHidden: true, viewState: form === null || form === void 0 ? void 0 : form.viewState, rowId: arrayIndex, disabled: getBoolValueFromRow(values, (_d = heading.formComponent) === null || _d === void 0 ? void 0 : _d.disabled), dataId: cellDataId && "".concat(cellDataId, "-").concat(cellIndex), dataTestId: cellDataTestId && "".concat(cellDataTestId, "-").concat(cellIndex), helperTooltip: helperTooltipContent })) : (getItemNodeFormatting(heading, values))));
                }),
                props.dropdown && ((_b = props.form) === null || _b === void 0 ? void 0 : _b.viewState) !== "edit" && (React.createElement(TableRowAction, __assign({ item: values, rowIndex: arrayIndex }, props))),
                props.drawer && (React.createElement(TableDrawer, __assign({ item: values, rowIndex: arrayIndex }, props)))));
        })));
}
export var useTableFormClasses = function () {
    var useStyles = createUseStyles({
        cellForm: {
            "& .radio-buttons": {
                marginBottom: 2,
            },
            "& .form-group": {
                marginBottom: 0,
                "& .checkbox": {
                    marginTop: 0,
                    marginBottom: 0,
                    "& label": {
                        paddingTop: 4,
                        paddingBottom: 4,
                        marginBottom: 0,
                    },
                },
                "& .help-block": {
                    marginTop: 0,
                    marginBottom: 0,
                },
                "& .form-control-static": {
                    paddingTop: 5,
                    minHeight: 30,
                },
                "& .form-control": {
                    margin: "4px 0",
                },
            },
        },
    });
    return useStyles();
};
